<template>
    <modal :appendToBody="true" :title="$t(concatTilte)" :visible.sync="isShowDialog" width="60%">
        <div class="content">
            <v-search :formContent="formContent" :SearchForm="SearchForm" :inline="true" :optareBtn="optareBtn"
                @resetFn="resetFn" @confirmFn="getListFn" @searchFn="getListFn" />
            <div class="componentPage">

                <el-table stripe v-loading="loading" ref="multipleTable" :data="tableData" tooltip-effect="dark"
                    style="width: 100%" :header-cell-style="headCellStyle" :cell-style="bodyCellStyle"
                    :height="tableHeight">
                    <el-table-column :label="$t('user.name')" show-overflow-tooltip prop="username">
                        <template #default="{ row }">
                            <i :class="statusFn(row.status)" :title="titleFn(row.status)"></i>
                            <span class="lh30">
                                {{ row.username }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('user.account')" show-overflow-tooltip prop="account" />
                    <el-table-column :label="$t('public.phone_num')" show-overflow-tooltip prop="mobile" />
                    <el-table-column :label="$t('public.email')" show-overflow-tooltip prop="email" />
                </el-table>
                <Pagination class="pagination" :total="total" :page.sync="SearchForm.iDisplayStart"
                    :limit.sync="SearchForm.iDisplayLength" @pagination="getListFn"></Pagination>
            </div>
        </div>



        <div slot="footer">
            <el-button type="primary" @click="isShowDialog = false">{{ $t('public.btn_close') }}</el-button>

        </div>
    </modal>
</template>

<script>
export default {
    props: ['concatTilte', 'concatShow', 'tableData', 'total', 'loading'],
    computed: {
        isShowDialog: {
            get: function () {
                return this.concatShow
            },
            set: function (val) {
                this.$emit('update:concatShow', val);//可以优化成model  或者minx
            }
        }

    },
    data() {
        return {
            SearchForm: {
                name: null
            },
            formContent: [
                {
                    id: 1,
                    text: this.$t("user.name"),
                    type: 'input',
                    paramsName: 'name',
                    isChooze: true,
                },
            ],
            optareBtn: [],
            tableHeight: "calc(100% - 60px)",
        }
    },
    methods: {
        resetFn() {
            this.SearchForm.name = null,
            this.$emit('getListFn')
        },
        statusFn(status) {
            return status === 1 ? 'el-icon-warning' : 'el-icon-warning-outline'
        },
        titleFn(status) {
            return this.$t(status === 1 ? this.$t('public.role_status_activity') : this.$t('public.role_status_cancel'))
        },
        getListFn() {
            this.$emit('getListFn', this.SearchForm.name)
        },
    }
}
</script>

<style lang="scss" scoped>
.content {
    width: 100%;
    height: 650px;
    display: flex;
    flex-direction: column;

    .componentPage {
        flex: 1;

        .lh30 {
            line-height: 30px;
        }

        .pagination {
            padding-top: 0;
            padding-right: 15px !important;
            display: flex;
            align-items: center;
            justify-content: flex-end;
        }
    }
}
</style>